var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9274 3.64469L2.45787 27.8005C2.15954 28.3172 2.00168 28.9029 2.00001 29.4995C1.99834 30.0961 2.15291 30.6827 2.44834 31.201C2.74378 31.7193 3.16977 32.1512 3.68395 32.4538C4.19813 32.7563 4.78256 32.919 5.37912 32.9255H34.3183C34.9148 32.919 35.4993 32.7563 36.0134 32.4538C36.5276 32.1512 36.9536 31.7193 37.2491 31.201C37.5445 30.6827 37.6991 30.0961 37.6974 29.4995C37.6957 28.9029 37.5379 28.3172 37.2395 27.8005L22.7699 3.64469C22.4654 3.14262 22.0366 2.72752 21.5249 2.43943C21.0132 2.15134 20.4359 2 19.8487 2C19.2615 2 18.6842 2.15134 18.1725 2.43943C17.6608 2.72752 17.232 3.14262 16.9274 3.64469V3.64469Z",
    stroke: "#004057",
    strokeWidth: 3.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8486 12.4255V19.2589",
    stroke: "#004057",
    strokeWidth: 3.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8486 26.0922H19.8649",
    stroke: "#004057",
    strokeWidth: 3.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fd91cd1042d332fa6b50bed029f74c7f.svg";
export { ForwardRef as ReactComponent };